module.exports = __webpack_public_path__ + "img/logo-kkpoints-s.059bfd2c.png";